import { render, staticRenderFns } from "./ProductFeatured.vue?vue&type=template&id=f190ddfa&scoped=true"
import script from "./ProductFeatured.vue?vue&type=script&lang=js"
export * from "./ProductFeatured.vue?vue&type=script&lang=js"
import style0 from "./ProductFeatured.vue?vue&type=style&index=0&id=f190ddfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f190ddfa",
  null
  
)

export default component.exports